var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { getThemeStyle } from "../../resources/functions/";
import "./ModuleAvatar.scss";

var ModuleAvatar = (_temp2 = _class = function (_Component) {
    _inherits(ModuleAvatar, _Component);

    function ModuleAvatar() {
        var _temp, _this, _ret;

        _classCallCheck(this, ModuleAvatar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getContent = function () {
            var _this$props = _this.props,
                name = _this$props.name,
                initials = _this$props.initials,
                title = _this$props.title,
                abbr = _this$props.abbr;


            if (!initials && name) {
                initials = name.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g);

                if (initials) {
                    initials = initials.join('');
                }
            }

            return {
                name: name,
                initials: initials,
                title: title,
                abbr: abbr
            };
        }, _this.getClassName = function () {
            var _this$props2 = _this.props,
                className = _this$props2.className,
                imageUrl = _this$props2.imageUrl,
                initials = _this$props2.initials;


            var classNames = [];

            classNames.push(className);

            if (imageUrl) {
                classNames.push(className + '--image');
            } else {
                classNames.push(className + '--initials');
            }

            return classNames.join(' ');
        }, _this.getStyle = function () {
            var _this$props3 = _this.props,
                style = _this$props3.style,
                theme = _this$props3.theme,
                imageUrl = _this$props3.imageUrl;


            if (theme) {
                return getThemeStyle(theme);
            }

            if (imageUrl) {

                style = _extends({}, style, {
                    backgroundImage: "url(" + imageUrl + ")"
                });
            }

            return style;
        }, _this.renderContent = function () {
            var _this$getContent = _this.getContent(),
                abbr = _this$getContent.abbr,
                title = _this$getContent.title,
                initials = _this$getContent.initials,
                name = _this$getContent.name;

            if (abbr) {
                return React.createElement(
                    "abbr",
                    { className: "abbr", title: title },
                    abbr
                );
            }

            if (initials) {
                return React.createElement(
                    "abbr",
                    { className: "initials", title: title },
                    initials
                );
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ModuleAvatar.prototype.render = function render() {
        var className = this.getClassName();
        var style = this.getStyle();

        /*
        
        const { icon } = this.props;
        
        if (icon) {
            return (
                <div className={className} style={{backgroundColor: "transparent"}}>
                    { icon }
                </div>
            )
        }
        
        */

        return React.createElement(
            "div",
            { className: className, style: style },
            this.renderContent()
        );
    };

    return ModuleAvatar;
}(Component), _class.defaultProps = {
    className: "admin-module__avatar",
    theme: undefined,
    style: {},
    imageUrl: "",
    name: undefined,
    initials: undefined,
    title: undefined,
    abbr: undefined
}, _temp2);


export default ModuleAvatar;